import { useStore } from "../../../../../helpers";
import { useRequestTypeMutation } from "../../../sr-hooks";
import { useTranslation } from "react-i18next";

export const useAddLocation = () => {
  const rootStore = useStore();
  const { t } = useTranslation("service_request_settings");

  const onAddLocation = async (payload: any) => {
    return rootStore.apiRequestHandler(
      "unified_service_request/sr-locations-add",
      payload,
      t("location_add_location_failed"),
    );
  };

  return useRequestTypeMutation(onAddLocation, t("location_add_location_success"));
};
